/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The verdict the client read off the eligibility endpoint, recorded on the progression so
 * the enrollment steps can branch on it.
 */
export interface AccessEligibilityMetadata {
  type: "access_eligibility";
  access_eligible: boolean;
}
